import React from "react";
import { Modal } from "antd";

import "../styles/components/popup.scss";

const Popup = ({
  isOpen,
  title,
  onOk,
  onCancel,
  children,
  footer,
  style,
  width,
}) => {
  return (
    <>
      <Modal
        title={title}
        open={isOpen}
        onOk={onOk}
        onCancel={onCancel}
        footer={footer}
        style={style}
        width={width}
        className="popup"
      >
        {children}
      </Modal>
    </>
  );
};

export default Popup;
